import React, { useState } from 'react';
import { Star } from 'lucide-react';

const PILLS = [
    "Polite",
    "Professional Conduct",
    "High Quality Work",
    "Punctual",
    "Good Communication",
    "Responsive",
    "Followed Instructions",
    "Safe Practices"
];

const RatingInput = ({ onSubmit, onCancel, role, submitting }) => {
    const [rating, setRating] = useState(0);
    const [comment, setComment] = useState('');
    const [selectedPills, setSelectedPills] = useState([]);

    const togglePill = (pill) => {
        if (selectedPills.includes(pill)) {
            setSelectedPills(selectedPills.filter(p => p !== pill));
        } else {
            setSelectedPills([...selectedPills, pill]);
        }
    };

    const handleSubmit = () => {
        if (rating === 0) return;
        onSubmit({
            rating,
            comment,
            pills: selectedPills
        });
    };

    return (
        <div className="bg-white p-6 rounded-lg border border-gray-100 shadow-sm">
            <h3 className="text-xl font-bold text-center mb-6 text-gray-800">
                Rate {role === 'employer' ? 'Employer' : 'Professional'}
            </h3>

            {/* Star Rating */}
            <div className="flex justify-center gap-2 mb-8">
                {[1, 2, 3, 4, 5].map((star) => (
                    <button
                        key={star}
                        onClick={() => setRating(star)}
                        className="focus:outline-none transform hover:scale-110 transition-transform"
                    >
                        <Star
                            size={32}
                            className={`${rating >= star ? "text-yellow-400 fill-yellow-400" : "text-gray-300"}`}
                        />
                    </button>
                ))}
            </div>

            {/* Highlights/Pills */}
            <div className="mb-6">
                <h4 className="text-base font-semibold mb-3 text-gray-700">Select Highlights</h4>
                <div className="flex flex-wrap gap-2">
                    {PILLS.map((pill) => (
                        <button
                            key={pill}
                            onClick={() => togglePill(pill)}
                            className={`px-3 py-1.5 rounded-full text-sm font-medium border transition-colors ${selectedPills.includes(pill)
                                    ? "bg-blue-100 border-blue-200 text-blue-700"
                                    : "bg-gray-50 border-gray-200 text-gray-600 hover:bg-gray-100"
                                }`}
                        >
                            {pill}
                        </button>
                    ))}
                </div>
            </div>

            {/* Comment Input */}
            <div className="mb-6">
                <h4 className="text-base font-semibold mb-3 text-gray-700">Add a Comment</h4>
                <textarea
                    className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 min-h-[100px] resize-y text-gray-700"
                    placeholder="Share your experience..."
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                />
            </div>

            {/* Buttons */}
            <div className="flex gap-3">
                {onCancel && (
                    <button
                        onClick={onCancel}
                        disabled={submitting}
                        className="flex-1 py-3 px-4 rounded-lg bg-gray-100 text-gray-600 font-semibold hover:bg-gray-200 transition-colors disabled:opacity-50"
                    >
                        Cancel
                    </button>
                )}
                <button
                    onClick={handleSubmit}
                    disabled={rating === 0 || submitting}
                    className="flex-1 py-3 px-4 rounded-lg bg-green-500 text-white font-semibold hover:bg-green-600 transition-colors disabled:bg-green-300 disabled:cursor-not-allowed shadow-sm"
                >
                    {submitting ? 'Submitting...' : 'Submit Review'}
                </button>
            </div>
        </div>
    );
};

export default RatingInput;
